/* tslint:disable:max-line-length */
import classname from 'classnames'
import * as React from 'react'
import { DefaultContent } from 'react-content-engine'

import Icon from 'components/Icon'
import { LOGO } from 'Icon/logo'
import { SOCIAL } from 'Icon/social'

import './Footer.scss'

interface FooterProps {
  available: boolean
  srprsmeLinks: JSX.Element
  infoLinks: JSX.Element
  phoneNumber: string
  icons: JSX.Element
  facebookUrl: string
  alternative?: boolean
}

const Footer: React.FC<FooterProps> = (props) => {
  const className = classname(
    'srprs-footer',
    props.alternative ? 'srprs-footer-alt' : '',
  )
  return (
    <footer className={className}>
      <nav className="wrapper-inner">
        <div className="wrapper-columns">
          <div className="column">
            <input
              type="radio"
              id="collapserow01"
              name="collapse"
              value="collapse01"
              defaultChecked={true}
            />
            <label htmlFor="collapserow01">srprs.me</label>
            <div className="collapsible">
              <ul>{props.srprsmeLinks}</ul>
            </div>
          </div>

          <div className="column">
            <input
              type="radio"
              id="collapserow02"
              name="collapse"
              value="collapse02"
            />
            <label htmlFor="collapserow02">
              <DefaultContent contentKey="information">
                Information
              </DefaultContent>
            </label>
            <div className="collapsible">
              <ul>{props.infoLinks}</ul>
            </div>
          </div>

          <div className="column">
            <input
              type="radio"
              id="collapserow03"
              name="collapse"
              value="collapse03"
            />
            <label htmlFor="collapserow03">
              <DefaultContent contentKey="keep-in-touch">
                Keep in touch
              </DefaultContent>
            </label>
            <div className="collapsible">
              <address className="vcard">
                <p>
                  <a href={'tel:' + props.phoneNumber}>{props.phoneNumber}</a>
                  <br />
                  hallo@srprs.me
                </p>
                <p className="adr">
                  <span className="street-address">Duivendrechtsekade 82</span>
                  <br />
                  <span className="postal-code">1096 AJ</span>
                  <span className="region"> Amsterdam</span>
                  <br />
                  <span className="country-name">
                    <DefaultContent contentKey="netherlands">
                      Nederland
                    </DefaultContent>
                  </span>
                </p>
              </address>
            </div>
          </div>

          <div className="column">
            <div className="pull-right">
              <div className="icons">{props.icons}</div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 328">
                  {LOGO.words}
                </svg>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="wrapper-footnotes">
          <span className="slogan">
            <DefaultContent contentKey="slogan">srprs.me</DefaultContent>
          </span>

          <ul className="wrapper-social">
            <li>
              <a href="//youtube.com/srprsme" target="_blank">
                <Icon icon={SOCIAL.youtube} />
              </a>
            </li>
            <li>
              <a href="//twitter.com/srprsme" target="_blank">
                <Icon icon={SOCIAL.twitter} />
              </a>
            </li>
            <li>
              <a href={props.facebookUrl} target="_blank">
                <Icon icon={SOCIAL.facebook} />
              </a>
            </li>
            <li>
              <a href="//instagram.com/srprsme" target="_blank">
                <Icon icon={SOCIAL.instagram} />
              </a>
            </li>
          </ul>

          <div className="pull-right">
            <div className="icons">{props.icons}</div>
            <div className="srprsme-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 328">
                {LOGO.words}
              </svg>
            </div>
          </div>
        </div>
      </nav>
    </footer>
  )
}

Footer.defaultProps = {
  alternative: false,
}

export default Footer
